export const handleRedirect = (url) => {
  window.location.href = url
}
